import { Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@perval/shared';

@Component({
  selector: 'p-wrapper',
  templateUrl: './p-wrapper.component.html',
  styleUrls: ['./p-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PWrapperComponent implements OnInit {
  @Input() titleWrapper!: string;
  @Input() withPreviousButton = false;
  @Input() withHomeButton = false;
  @Input() showFooter!: boolean;
  @Input() showHeader = true;
  @Input() goBackLabel: string = 'Retour';

  private previousUrl!: string;

  constructor(
    private readonly location: Location,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    const previousNavigation =
      this.router.getCurrentNavigation()?.previousNavigation;
    if (previousNavigation) {
      this.previousUrl =
        previousNavigation.previousNavigation?.finalUrl?.toString() ?? '';
    }
  }

  goBack(): void {
    if (this.previousUrl) {
      const newUrl = this.previousUrl.includes('?')
        ? this.previousUrl.split('?')[0]
        : this.previousUrl;
      this.location.go(newUrl);
      window.location.reload();
    } else {
      this.location.back();
    }
  }

  goHome(): void {
    window.location.href = `${environment.host}/content/accueil`;
  }
}
